import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpGoogleLogout, HttpGoogleLogoutOptions} from '@features/settings/http/settings.http.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

export const useGoogleLogout = (
    options?: Omit<UseMutationOptions<unknown, unknown, HttpGoogleLogoutOptions>, 'mutationFn'>
) => {
    const queryClient = useQueryClient()
    return useMutation<unknown, unknown, HttpGoogleLogoutOptions>({
        ...options,
        mutationFn: ({payload}) => httpGoogleLogout({payload}),
        onSuccess: async (data, variables, context) => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.ME]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ME]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REQUIRED_ACTIONS]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
